<template>
  <v-app id="app">
    <Appbar></Appbar>

    <NavigationDrawer></NavigationDrawer>

    <v-content>
      <v-fade-transition>
        <router-view class="content"></router-view>
      </v-fade-transition>
    </v-content>

    <ErrorAlert></ErrorAlert>
  </v-app>
</template>

<style lang="scss">
@import '@/assets/scss/app.scss'
</style>

<script>
import { mapGetters } from 'vuex'
import Appbar from '@/components/Appbar.vue'
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import ErrorAlert from '@/components/Utils/ErrorAlert.vue'
import { Capacitor } from '@capacitor/core'
import { FCM } from '@capacitor-community/fcm';
import { PushNotifications } from '@capacitor/push-notifications';
import { SplashScreen } from '@capacitor/splash-screen';

export default {
  name: 'App',

  components: {
    ErrorAlert,
    Appbar,
    NavigationDrawer
  },

  data() {
    return {
      mobile: false,
      prevScroll: 0,
      touchStart: { x: 0, y: 0 },
      touchMove: { x: 0, y: 0 },
      touchDelta: 0
    }
  },

  computed: {
    ...mapGetters([
      'loggedIn',
      'topics',
    ]),
  },

  mounted() {
    SplashScreen.hide()
    this.subscribeChannels()
  },

  methods: {
    // subscribe anonymous users to all notification topics
    subscribeChannels() {
      if (Capacitor.isPluginAvailable('PushNotifications') && !this.loggedIn) {

        PushNotifications
          .register()
          .then(() => {
            for (let topic in this.topics) {
              FCM.subscribeTo({ topic })
            }
          })
      }
    },
  },
}
</script>
